import d3 from "d3v3";
import nv from "./nv.d3";
import _ from "lodash";
import { parseUnitMapping } from "../../lib/utils";

var insertedCharts = {};

const draw = (id, chartId, dataPoints, allYearsData, unitMappingStr, selectedYear, options) => {
  const highlightedItems = options.highlightedItems ? options.highlightedItems : [];
  var margins = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  };
  d3.select(id)
    .append("svg")
    .attr("id", chartId)
    .attr("viewBox", "0 0 600 600")
    .attr("preserveAspectRatio", "xMidYMax")
    .append("g")
    .attr("class", "chartGraphics")
    .attr("transform", "translate(" + margins.left + "," + margins.top + ")");
  // register our custom symbols to nvd3
  // make sure your path is valid given any size because size scales if the chart scales.
  nv.utils.symbolMap.set("thin-x", function(size) {
    size = Math.sqrt(size);
    return "M" + -size / 2 + "," + -size / 2 + "l" + size + "," + size + "m0," + -size + "l" + -size + "," + size;
  });

  // create the chart
  var chart;
  nv.addGraph(function() {
    chart = nv.models
      .scatterChart()
      .margin({ left: 30, right: 30, top: 30, bottom: 30 })
      .width(600)
      .height(600)
      .showDistX(false)
      .showDistY(false)
      .useVoronoi(true)
      .showLegend(false)
      .forceX([-0.2, 100.2])
      .forceY([-0.2, 100.2])
      .color(d3.scale.category10().range())
      .duration(1000)
      .pointRange([500, 3000])
      .labeledItems(highlightedItems);

    chart.xAxis.showMaxMin(false).tickValues([0, 60, 70, 80, 100]);

    chart.yAxis.showMaxMin(false).tickValues([0, 60, 70, 80, 100]);

    chart.tooltip.contentGenerator(function(obj) {
      return "<p><strong>" + obj.point.label + ":</strong> (" + obj.point.x + "," + obj.point.y + ")</p>";
    });

    const unitMapping = parseUnitMapping(unitMappingStr);

    const labels = new Set();
    Object.keys(unitMapping).forEach(label => labels.add(label));
    Object.values(unitMapping).forEach(map => Object.values(map).forEach(label => labels.add(label)));

    dataPoints.forEach(dataPoint => {
      const label = dataPoint.key;
      labels.add(label);
    });


    const pointsToAdd = {};
    allYearsData.forEach(dataset => dataset.data.points.forEach(point => {
      const label = point.key;
      if (!labels.has(label)) {
        labels.add(label);
        pointsToAdd[label] = point;
      }
    }));

    let sortedPoints = [...dataPoints, ...Object.values(pointsToAdd)]
      .map(dataPoint => ({ ...dataPoint, values: dataPoint.values.map(value => ({...value, size: 5})) }))
      .sort(function(a, b) {
        var aSortValue = 0;
        var bSortValue = 0;
        if (!(highlightedItems && highlightedItems.indexOf(a.key) > -1)) {
          aSortValue = 1000000;
        }
        if (!(highlightedItems && highlightedItems.indexOf(b.key) > -1)) {
          bSortValue = 1000000;
        }
        aSortValue += parseInt(a.values[0].count, 10);
        bSortValue += parseInt(b.values[0].count, 10);

        return bSortValue - aSortValue;
      });
    sortedPoints = _.sortBy(sortedPoints, function(point) {
      return point.color === "#000" ? 1 : 0;
    });

    d3.select(id + " svg")
      .datum(sortedPoints)
      .call(chart);

    updateData(id, dataPoints, unitMappingStr, selectedYear);

    insertedCharts[id] = chart;
    return chart;
  });
};

const updateData = (id, dataPoints, unitMappingStr, selectedYear) => {
  const mappedPoints = {};
  dataPoints.forEach(point => {
    mappedPoints[point.values[0].key] = point;
  });
  const unitMapping = parseUnitMapping(unitMappingStr);
  const dotSizeMultiplier = 0.9;
  const chartAreaMultiplier = 5.39;
  d3.selectAll(`${id} path`)
    .attr("data", function(d) {
      d3.select(this.parentNode)
        .selectAll('path, text')
        .transition()
        .duration(1000)
        .attr("transform", () => {
          if (d && d[0]) {
            let key = d[0].key;
            if (unitMapping[key] && unitMapping[key][selectedYear]) {
              key = unitMapping[key][selectedYear];
            }
            const point = mappedPoints[key];
            let scale = 0;
            if (point) {
              d[0].x = point.values[0].x;
              d[0].y = point.values[0].y;
              d[0].size = point.values[0].size;
              if (dataPoints.length === 1) {
                scale = 1;
              } else {
                scale = (((d[0].size / 5) - 1) * dotSizeMultiplier) + 1;
              }
            }
            return `translate(${d[0].x * chartAreaMultiplier}, ${chartAreaMultiplier * 100 - d[0].y * chartAreaMultiplier}) scale(${scale})`;
          }
        });
    });
};

export default { draw, updateData };



// WEBPACK FOOTER //
// ./src/components/ScatterPlot/scatterplot.js